import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

import { computed, ref, toRef } from "vue";
import VatTuDetailModal from "@/components/vat-tu/VatTuDetailModal.vue";
import { LOAI_DINH_MUC } from "@/core/constants/const";
import useVatTu from "@/core/hooks/use-vat-tu";
import type { IVatTuXuatKhoResponseBase } from "@/core/interfaces/ApiResponses";
import type { BbgtKhoItem } from "@/types/phieu-xuat-kho";
import type { IVatTuSelectedInKho } from "@/core/interfaces/Models";
import { useProvidePhieuXuatKhoTableCellApi } from "./composables/useProvidePhieuXuatKhoTableCellApi";
import PhieuXuatKhoVatTuTableShell from "./PhieuXuatKhoVatTuTableShell.vue";
import type {
  IPhieuXuatKhoSelectedKhoSummary,
  IPhieuXuatKhoSuppliesQuantityRow,
  PhieuXuatKhoLoaiPhieu,
  PhieuXuatKhoSuppliesSource,
  PhieuXuatKhoTableRow,
  PhieuXuatKhoVatTuTableMode,
} from "./types";


export default /*#__PURE__*/_defineComponent({
  __name: 'PhieuXuatKhoVatTuTable',
  props: {
    mode: { default: "pick" },
    source: { default: "bbgt" },
    loaiPhieu: {},
    loaiDinhMuc: {},
    readonly: { type: Boolean, default: false },
    supplies: { default: () => [] },
    quantityRows: { default: () => [] },
    groups: { default: () => [] },
    vatTuSelectedInKho: { default: () => [] },
    selectingKhoItem: { default: null },
    isLoading: { type: Boolean, default: false },
    showThuHoiColumns: { type: Boolean, default: true },
    showLyDoColumn: { type: Boolean, default: false },
    showDeleteAction: { type: Boolean, default: false },
    showPickFooter: { type: Boolean, default: false },
    isEditMode: { type: Boolean, default: false }
  },
  emits: ["quantity-change", "delete-item"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const { isTextDangerColumn } = useVatTu();
const selectedVatTuId = ref<number | undefined>(undefined);

const {
  buildGroupTableData,
  footerRowClassName,
  footerSpanMethod,
  isSummaryMode,
  pickTableData,
  visibleColumns,
} = useProvidePhieuXuatKhoTableCellApi({
  mode: computed(() => props.mode),
  source: computed(() => props.source ?? "bbgt"),
  loaiPhieu: computed(() => props.loaiPhieu),
  readonly: computed(() => props.readonly),
  isEditMode: computed(() => props.isEditMode),
  showThuHoiColumns: computed(() => props.showThuHoiColumns),
  showLyDoColumn: computed(() => props.showLyDoColumn),
  showDeleteAction: computed(() => props.showDeleteAction),
  showPickFooter: computed(() => props.showPickFooter),
  loaiDinhMuc: toRef(props, "loaiDinhMuc"),
  supplies: computed(() => (props.supplies ?? []) as PhieuXuatKhoTableRow[]),
  quantityRows: computed(() => props.quantityRows ?? []),
  selectingKhoItem: computed(() => props.selectingKhoItem),
  vatTuSelectedInKho: computed(() => props.vatTuSelectedInKho ?? []),
  onQuantityChange: (rows) => emit("quantity-change", rows),
  onDeleteItem: (idVatTu) => emit("delete-item", idVatTu),
});

const emptyText = computed(() => {
  if (!props.supplies?.length) {
    if (props.source === "bbgt" && !props.selectingKhoItem) {
      return "Lựa chọn kho xuất vật tư tương ứng";
    }

    return "Không có vật tư xuất kho";
  }

  if (props.source === "bbgt" && props.selectingKhoItem) {
    return "Kho hiện tại không có vật tư tương ứng";
  }

  return "Chưa có vật tư được chọn";
});

return (_ctx: any,_cache: any) => {
  const _directive_loading = _resolveDirective("loading")!

  return (_unref(isSummaryMode))
    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.groups, (group, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: "mb-4"
        }, [
          _withDirectives(_createVNode(PhieuXuatKhoVatTuTableShell, {
            data: _unref(buildGroupTableData)(group),
            "enable-footer": true,
            "footer-row-class-name": _unref(footerRowClassName),
            "footer-span-method": _unref(footerSpanMethod),
            "visible-columns": _unref(visibleColumns),
            "empty-text": "Chưa có vật tư",
            size: "medium"
          }, null, 8, ["data", "footer-row-class-name", "footer-span-method", "visible-columns"]), [
            [_directive_loading, _ctx.isLoading]
          ])
        ]))
      }), 128))
    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
        _createVNode(VatTuDetailModal, {
          "vat-tu-id": selectedVatTuId.value,
          onClose: _cache[0] || (_cache[0] = ($event: any) => (selectedVatTuId.value = undefined))
        }, null, 8, ["vat-tu-id"]),
        _withDirectives(_createVNode(PhieuXuatKhoVatTuTableShell, {
          "cell-class-name": _unref(isTextDangerColumn),
          data: _unref(pickTableData),
          "enable-footer": _ctx.showPickFooter,
          "footer-row-class-name": _unref(footerRowClassName),
          "footer-span-method": _unref(footerSpanMethod),
          "visible-columns": _unref(visibleColumns),
          "empty-text": emptyText.value,
          "scrollbar-always-on": true
        }, null, 8, ["cell-class-name", "data", "enable-footer", "footer-row-class-name", "footer-span-method", "visible-columns", "empty-text"]), [
          [_directive_loading, _ctx.isLoading]
        ])
      ], 64))
}
}

})